<!-- =========================================================================================
    File Name: DashboardEcommerce.vue
    Description: Dashboard - Ecommerce
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div>
       <div class="vx-row">

      <!-- CARD 3: ORDER RECIEVED -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line icon="UsersIcon" :statistic="studentCount" statisticTitle="총 수강생수" :chartData="ordersRecevied.series" color="warning" type="area"></statistics-card-line>
      </div>

      <!-- CARD 3: ORDER RECIEVED -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line icon="ShoppingBagIcon" :statistic="ordersheetCount" statisticTitle="교재주문 건수" :chartData="ordersRecevied.series" color="success" type="area"></statistics-card-line>
      </div>

      <!-- CARD 3: ORDER RECIEVED -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line icon="UsersIcon" :statistic="teacherCount" statisticTitle="총 교직원수" :chartData="ordersRecevied.series" color="danger" type="area"></statistics-card-line>
      </div>
        </div>
    </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import VueApexCharts from 'vue-apexcharts'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import analyticsData from '@/views/dashboard/ui-elements/card/analyticsData.js'
import ChangeTimeDurationDropdown from '@/components/ChangeTimeDurationDropdown.vue'

import { fetchData } from '@/api/module'

export default{
  components: {
    VueApexCharts,
    StatisticsCardLine,
    VuePerfectScrollbar,
    ChangeTimeDurationDropdown
  },
  data () {
    return {

      subscribersGained: {},
      revenueGenerated: {},
      quarterlySales: {},
      ordersRecevied: {},

      revenueComparisonLine: {},
      goalOverview: {},

      browserStatistics: [],
      clientRetentionBar: {},

      sessionsData: {},
      chatLog: [],
      chatMsgInput: '',
      customersData: {},

      analyticsData,
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      instituteCount: 0,
      studentCount: 0,
      ordersheetCount: 0,
      teacherCount: 0,
      institute_data: null,
      student_data: null,
      ordersheet_data: null,
      teacher_data: null
    }
  },
  computed: {
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    getUserInfo () {
      return this.$store.getters.getUserInfo
    }
  },
  methods: {
    async fetch_institute_data () {
      const { data } = await fetchData('/dashboard/institute')
      console.log(data)
      this.institute_data = data.data
      this.instituteCount = this.institute_data.count
    },
    async fetch_student_data () {
      const { data } = await fetchData('/dashboard/student', {instituteSeq: this.getUserInfo.instituteSeq})
      console.log(data)
      this.student_data = data.data
      this.studentCount = this.student_data.count
    },
    async fetch_ordersheet_data () {
      const { data } = await fetchData('/dashboard/ordersheet', {instituteSeq: this.getUserInfo.instituteSeq})
      console.log(data)
      this.ordersheet_data = data.data
      this.ordersheetCount = this.ordersheet_data.count
    },
    async fetch_teacher_data () {
      const { data } = await fetchData('/dashboard/teacher', {instituteSeq: this.getUserInfo.instituteSeq})
      console.log(data)
      this.teacher_data = data.data
      this.teacherCount = this.teacher_data.count
    }
  },
  mounted () {
    const scroll_el = this.$refs.chatLogPS.$el || this.$refs.chatLogPS
    scroll_el.scrollTop = this.$refs.chatLog.scrollHeight
  },
  created () {
    this.fetch_institute_data()
    this.fetch_student_data()
    this.fetch_ordersheet_data()
    this.fetch_teacher_data()
  }
}
</script>

<style lang="scss">
.chat-card-log {
    height: 400px;

    .chat-sent-msg {
        background-color: #f2f4f7 !important;
    }
}
</style>
